export default "/assets/images/milaair-order-bg-sm.b9f91fe33bf56900.jpg";